export default class UserComplaintQuery{
	public userId: string ="";
	public fromDate: string ="";
	public toDate: string ="";
}